'use client'

import { isbot } from 'isbot'

import * as gtag from '@lib/gtag'

import getCookieConsentValue from './get-cookie-consent-value'

export default async function sendEventToAnalytics(
  event: string,
  params: Record<string, string | boolean | string[]>,
): Promise<void> {
  const { mixpanel } = await import('@lib/mixpanel')
  const userAgent = navigator.userAgent
  const isCrawler = isbot(userAgent)
  // iPadOS Safari defaults to desktop-class browsing and sends a Macintosh user agent
  // indistinguishable from macOS, so touch support is the only signal left — no Mac has a
  // touchscreen. Costs us iPhones with "Request Desktop Website" on, which is opt-in and rare.
  const isTablet =
    /iPad|Tablet|Android(?!.*Mobile)/i.test(userAgent) || (/Macintosh/.test(userAgent) && navigator.maxTouchPoints > 1)

  gtag.event(event, params)
  mixpanel.track(event, {
    ...params,
    areCookiesAccepted: getCookieConsentValue(),
    userAgent,
    isCrawler,
    deviceType: isTablet ? 'tablet' : /Mobile|iPhone|Android/i.test(userAgent) ? 'smartphone' : 'desktop',
  })
  // The Reddit pixel is a conversion pixel: crawler hits degrade ad targeting.
  if (!isCrawler && window.rdt) {
    window.rdt('track', 'Custom', {
      customEventName: event,
      ...params,
    })
  }
}
